import { AgGridReact } from 'ag-grid-react';
import React, { useState, useRef, useMemo, useCallback, useEffect } from 'react';
import { getTextComparators } from '../../../library/comparators';
import { dateTimeFormatter } from '../../../library/formatters';
import { getJobHistory } from '../../../apis/jobApi';
import { UpdateService } from '../../../services/UpdateService';
import { getFilesById } from '../../../apis/fileApi';

export const JobHistory = ({jobId, active, isJobRunning}) => {

    const [jobHistoryData, setJobHistoryData] = useState();
    const gridRef = useRef();
    const pageSizeOptions = [15, 25, 50, 100];
    const defaultPageSize = 25;
    
    const activeRef = useRef(active);
    
    useEffect(() => {
        activeRef.current = active;
        if (active && gridRef.current) {
            gridRef.current.api.refreshInfiniteCache();
        }
    }, [active]);

    const getHistory = async (params) => {
        if (activeRef.current)
        {
            const response = await getJobHistory(jobId, params.sortModel, params.filterModel, params.startRow, params.endRow - params.startRow)
                .then(response => {
                    return {total: response.total, data: response.data.map((fileRow => {
                        const editedOn = fileRow.values.map(value => value.key).join(', ');
                        return {application: fileRow.application, created: fileRow.created, operationSummary: `${fileRow.operation} ${editedOn}`, additionalData: fileRow.values, operation : fileRow.operation, user:fileRow.user }
                    })
                )};
            });
                    
            // if on or after the last page, work out the last row.
            let lastRow = response.total;
            params.successCallback(response.data, lastRow);
        }
    }

    const onGridReady = useCallback( async (params) => {
        const dataSource = {
          rowCount: undefined,
          getRows: getHistory
        };
        params.api.setGridOption('datasource', dataSource);
    });

    const [colDefs, setColDefs] = useState([
        {field: "created", headerName: "Created", valueFormatter: dateTimeFormatter, filter:false, sortable: true},
        {field: "application.name", headerName: "Application",  filter:false, sortable: false},
        {field: "operationSummary", headerName: "Operation Summary", sortable: false, filter:false},
        {field: "user.name", headerName: "User", cellRenderer:HistoryUserCell, sortable: false, filter:false},
        {field: "values", headerName: "Detail", cellRenderer:HistoryDetailCell, sortable: false, filter:false},
        
    ]);
    
    const defaultColDef = useMemo(() => {
        return {
        flex: 1
        };
    }, []);
  
    const rowSelection = useMemo(() => {
        return {
            mode: 'singleRow',
            checkboxes: false,
            enableClickSelection: true,
        };
    }
    , []);

    const initialState =  useMemo(() => {
        return {
            rowSelection:["1"],
        };
    }, []);

    const onRowClicked = useCallback(async(event) => {
        setJobHistoryData(event.data);
    },[])

    return <>
        <div className="ag-theme-quartz">
            <AgGridReact
                defaultColDef={defaultColDef}
                suppressClickEdit={true}
                ref = {gridRef}
                pagination={true}
                columnDefs={colDefs}
                rowModelType={'infinite'}
                rowSelection={rowSelection}
                initialState={initialState}
                onRowClicked={onRowClicked}
                paginationPageSizeSelector={pageSizeOptions}
                paginationPageSize={defaultPageSize}
                onGridReady={onGridReady}
                cacheBlockSize={defaultPageSize}
                cacheOverflowSize={2}
                maxConcurrentRequests={2}
                infiniteInitialRowCount={1}
                maxBlocksInCache={2}
            />
        </div>
        <UpdateService updateDataFunction={() => gridRef.current.api.refreshInfiniteCache()} gridRef={gridRef} active={active} isJobRunning={isJobRunning}/>
    </>
};



const HistoryUserCell = ({data}) => {
    if(data == null || data.user == null) {
        return<div className='text-muted'>Not available</div>;
    }
    return <>{data.user.name}</>
}

const HistoryDetailCell = ({data}) => {
    const [historyDetails, setHistoryDetails] = useState(null);
    const [fileHistoryDetails, setFileHistoryDetails] = useState(null);
    
    useEffect(() => {
        async function getData(){
            if(data === undefined || data === null)
            {
                setHistoryDetails(null)
            }
            else
            {
                const operationSummary = data.operationSummary;
                
            
                if (operationSummary.includes("Add"))
                {
                    setFileHistoryDetails(null)
                    setHistoryDetails(data.operationSummary);
                }
                else if(operationSummary.includes("Edit Files"))
                {
                    const diffValues = data.additionalData.map((data) => 
                    {
                        const {key, newValue, oldValue} = data;
                        const newValueArray = newValue.split(',');
                        const oldValueArray = oldValue ? oldValue.split(',') : [];
                        const diffArray = newValueArray.filter(value => !oldValueArray.includes(value));          
                        return {diff: diffArray};
                    });
                    const fileDetailsResult = getFilesById(diffValues[0].diff);
                    const test = (await fileDetailsResult).map(file => file.fileName);
                    setHistoryDetails(`Added files: ${test.join(', ')}`);
                }
                else if(operationSummary.includes("Edit State"))
                {
                    const oldState  = data.additionalData[0].oldValue;
                    const newState  = data.additionalData[0].newValue;
                    setHistoryDetails(`State change from ${oldState} to ${newState}`)
                }
                else 
                {
                    setFileHistoryDetails(null)
                }
            }
        }
        const result = getData().catch(console.error)

    }, [data])

    return <>
            {historyDetails === null ? 
            <div className='text-muted'>Not available</div> : historyDetails}    
         </>
}